  <template>

    <a-card>
      <div class="btn-group">
        <a-button type="primary" @click="onCreate">新增</a-button>
      </div>
      <div>
        <a-table :loading="loading" :columns="columns" :dataSource="dataSource" :pagination="pagination"
            rowKey="id">
          <div slot="action" slot-scope="row">
            <a-button type="link" size="small" @click="onView(row)"
                >编辑</a-button
              >
              <a-button type="link" size="small" @click="toggleEnable(row)"
                >{{row.status=='0'? "停用" : "启用"}}</a-button
              >
               <a-popconfirm
                title="确认删除吗?"
                ok-text="是"
                cancel-text="否"
                @confirm="dels(row.id)"
              >
                <a-button type="link" size="small">删除</a-button>
              </a-popconfirm>
          </div>
        </a-table>
      </div>
    </a-card>
</template>

<script>
import * as service from '@/services/material';
const columns = [
  {
    title: "标题",
    dataIndex: "title",
  },
  {
    title: "关联离校批次",
    dataIndex: "batchName",
  },
  {
    title: "状态",
    dataIndex: "status",
    customRender: (text) => {
      return text == 0 ? "启用" : "停用";
    },
  },
  {
    title: "操作",
    width:'200px',
    scopedSlots: {
      customRender: "action",
    },
  }
];

const dataSource = [];

export default {
  name: "MaterialScienceManagement",
  data() {
    return {
      params: {
        pageIndex: 1,
        pageSize: 10,
      },
      loading: false,
      columns: columns,
      dataSource: dataSource,
      pagination: {
        pageSize: 10,
        showTotal: (total) => `共${total}条`,
        current: 1,
        total: 0,
        onChange: (current) => this.onPageChange(current),
      },
      currentItem:{
         "details": [
            {
                "id": "5d91f5cd-9c76-4873-8969-8786e2c90d80",
                "code": "12",
                "name": "232",
                "materialId": "17de569e-45b2-417e-8fab-70d4f519a462",
                "sflq": "0"
            },
         ]
      },
    };
  },
  methods: {
    onCreate() {
      this.$router.push("/settings/material-science");
    },
    onView(row){
      this.$router.push({
        path: "/settings/material-science",
        query: {
          id: row.id,
        },
      });

    },
    onPageChange(page) {
      this.params.pageIndex = page;
      this.loadData();
    },
    async loadData() {
      this.dataSource = [];
      this.loading = true;
      const d = await service.findAll(this.params);
      this.loading= false;
      this.dataSource = d.records;
      this.pagination.current = d.current;
      this.pagination.total = d.total;
    },
    search() {
      console.log("search");
      this.onPageChange(1);
    },
    rest() {
      this.params = {};
      this.onPageChange(1);
    },
    async toggleEnable(row){
      if(row.status==0){
        await service.disable({id:row.id})
      }else{
        await service.enable({id:row.id})
      }
      this.$message.success("操作成功");
      this.loadData();
    },
    async dels(ids){
      await service.dels({ids})
      this.$message.success("操作成功");
      this.loadData();
    }
  },
  async mounted() {
    this.loadData();
  },
};
</script>

<style lang="less" scoped>
</style>
